document.addEventListener("DOMContentLoaded", function () {
  // Get references to the elements
  const sizeChartSlide = document.getElementById("sizeChartModal");
  const overlay = document.getElementById("overlay");
  const sizeChartTrigger = document.querySelector(".size-chart-trigger");
  const closeBtn = document.querySelector(".close-btn");

  // Ensure that elements exist before proceeding
  if (sizeChartSlide && overlay && sizeChartTrigger && closeBtn) {
    // Toggle the size chart and overlay when the "Size Chart" link is clicked
    sizeChartTrigger.addEventListener("click", function () {
      toggleSizeChart();
    });

    // Close the size chart and hide the overlay when the close button is clicked
    closeBtn.addEventListener("click", function () {
      toggleSizeChart();
    });

    // Function to toggle the size chart visibility and background overlay
    function toggleSizeChart() {
      if (
        sizeChartSlide.style.display === "none" ||
        sizeChartSlide.style.display === ""
      ) {
        sizeChartSlide.style.display = "block"; // Show the size chart
        overlay.style.display = "block"; // Show the overlay
        document.body.classList.add("no-scroll"); // Disable scrolling on the main body
        setTimeout(function () {
          sizeChartSlide.classList.add("show"); // Add the 'show' class for sliding animation
        }, 10); // Delay to allow display:block to take effect before transition
      } else {
        sizeChartSlide.classList.remove("show"); // Start sliding out
        overlay.style.display = "none"; // Hide the overlay
        document.body.classList.remove("no-scroll"); // Re-enable scrolling on the main body
        setTimeout(function () {
          sizeChartSlide.style.display = "none"; // Hide the size chart after the animation
        }, 500); // Wait for the sliding transition to complete
      }
    }
  } else {
    console.error("One or more elements not found in the DOM.");
  }
});
